import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const D02DonutChart1 = ({ filterCriteria }) => {
  const [favorableCount, setFavorableCount] = useState(0);
  const [neutralCount, setNeutralCount] = useState(0);
  const [unfavorableCount, setUnfavorableCount] = useState(0);
  const [noResponseCount, setNoResponseCount] = useState(0);

  useEffect(() => {
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected for this key, include all items
        }
        return filterCriteria[key].includes(item[key]);
      });
    };

    const filteredData = jsonData.filter(filterData);

    let favorable = 0;
    let neutral = 0;
    let unfavorable = 0;
    let noResponse = 0;

    filteredData.forEach((response) => {
      const { MQ0026 } = response;

      if (MQ0026 === 4 || MQ0026 === 5) {
        favorable++;
      } else if (MQ0026 === 3) {
        neutral++;
      } else if (MQ0026 === 1 || MQ0026 === 2) {
        unfavorable++;
      } else {
        noResponse++;
      }
    });

    setFavorableCount(favorable);
    setNeutralCount(neutral);
    setUnfavorableCount(unfavorable);
    setNoResponseCount(noResponse);
  }, [filterCriteria]);

  useEffect(() => {
    const optionsDonut1 = {
      series: [noResponseCount, unfavorableCount, neutralCount, favorableCount],
      labels: ["No Response", "Unfavorable", "Neutral", "Favorable"],
      colors: ["#bab0ac", "#f28e2b", "#f1ce63", "#499894"],
      chart: {
        type: "donut",
        height: "300px",
        toolbar: {
          show: true,
        },
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: 5,
          },
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "16px",
        },
      },
    };

    const donut1 = new ApexCharts(
      document.querySelector("#donut-1"),
      optionsDonut1
    );
    donut1.render();

    // Clean up the chart on component unmount
    return () => {
      donut1.destroy();
    };
  }, [favorableCount, neutralCount, unfavorableCount, noResponseCount]);

  return (
    <div>
      <div id="donut-1"></div>
    </div>
  );
};

export default D02DonutChart1;
